import { EventEmitter, Injectable  } from '@angular/core';
import { ApiService } from "./api.service";
import { ApiCollectionResponse, UserGroup } from "../app/app.interfaces";
import { EventService } from "./event.service";
import { IonicHelper } from "../helpers/ionic.helper";

@Injectable()
export class UserGroupService {
  
  public initialized: EventEmitter<void> = new EventEmitter();
  public isInitialized: boolean = false;
  public userGroups: UserGroup[] = null;
  
  public activeUserGroup: UserGroup = null;
  
  
  constructor(private apiService: ApiService,
							private ionic: IonicHelper,
							private eventService: EventService) {

  }

  private async getPaginatedUserGroups(): Promise<UserGroup[]> {
    let userGroups = [];
    let page = 1;
    let hasNextPage = true;
    do {
      
      const response = (await this.apiService.getCollection(`user_groups?page=${page}`));

      userGroups = [...userGroups, ...response.items];
      hasNextPage = !!(response.view.pages && response.view.pages.next);
      page++;
    } while (hasNextPage);

    return userGroups;
  }

  public loadUserGroups(): void {
    this.getPaginatedUserGroups().then((userGroups: UserGroup[]) => {
			this.userGroups = userGroups;
			this.isInitialized = true;
			this.initialized.emit();
		}).catch((err) => {
    	console.error(err);
		});
  }

  public allAsync(): Promise<UserGroup[]> {
    return new Promise<UserGroup[]>((resolve) => {
      this.afterInit().then(() => {
        resolve(this.userGroups);
      })
    });
  }

	public get(userGroupIri: string): UserGroup {
    if(!this.isInitialized) return null;
    return this.userGroups.find(userGroup => userGroup['@id'] === userGroupIri);     
  }
  
  public getAsync(userGroupIri: string): Promise<UserGroup> {    
    return new Promise((resolve) => {
      this.afterInit().then(()=>{
        resolve(this.userGroups.find(userGroup => userGroup['@id'] === userGroupIri));     
      });  
    });    
  }
  
  public setActiveUserGroup(userGroup: UserGroup){
    if(userGroup) {
      let currentActive = this.userGroups.find(userGroup => userGroup.active);
      if (currentActive) currentActive.active = false;

      userGroup.active = true;
      this.activeUserGroup = userGroup;
    }
  }
  
  public unsetActiveUserGroup(){
    if(this.activeUserGroup) {
      this.activeUserGroup.active = false;
      this.activeUserGroup = null;
    }
  }
  
  public setActiveUserGroupById(userGroupId: Number): Promise<UserGroup> {
    
    return new Promise((resolve, reject) => {
      this.afterInit().then(() => {
        let newActiveUserGroup = this.findById(userGroupId);
        if(!newActiveUserGroup) {
          reject();
        }
        else {
          this.setActiveUserGroup(newActiveUserGroup);
          resolve(newActiveUserGroup);
        }
        
      });
    });
  }
  
  public findById(userGroupId: Number): UserGroup {
    if(!this.isInitialized) return null;
    return this.userGroups.find(userGroup => userGroup.id === userGroupId);
  }
  
  
  public afterInit(): Promise<void> {    
    return new Promise((resolve) => {
      if (this.isInitialized) {
        resolve();
      }
      else {
        this.initialized.subscribe(() => {
          resolve();
        });
      }
    });
  }
  
  
}



// WEBPACK FOOTER //
// ./src/services/user-group.service.ts